export default __webpack_public_path__ + "assets/src/objects/HouseTexture1.png";